import { useState } from 'react';

import { PlanCard } from '@page/workspace-plan/plan-card/plan-card';
import { CardWrapper, PlanTypeButton, PlanTypeWrapper } from '@page/workspace-plan/workspace-plan.style';
import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { ButtonTypeEnum } from '@atom/button/button.enum';
import { BillingTypeEnum } from '@enum/billing-type.enum';
import { useCreateCustomerPortalMutation, useLoadPlansQuery } from '@hook/billing/billing.hooks';

export const WorkspacePlanPage = () => {
  const { data } = useLoadPlansQuery();
  const [currentType, setType] = useState(BillingTypeEnum.Monthly);
  const [createCustomerPortal] = useCreateCustomerPortalMutation();

  const products = data?.data.filter((product) => !product.isBasePlan && product.type === currentType) ?? [];

  const onManageSubscriptionClick = async () => {
    const result = await createCustomerPortal().unwrap();
    window.location.href = result.data.url;
  };

  return (
    <PageWrapper>
      <PageTitle>Upgrade Workspace plan</PageTitle>
      <PlanTypeWrapper>
        {Object.entries(BillingTypeEnum).map(([name, type]) => (
          <PlanTypeButton
            key={type}
            size='middle'
            type={currentType === type ? ButtonTypeEnum.Primary : ButtonTypeEnum.Default}
            onClick={() => setType(type)}
          >
            {name}
          </PlanTypeButton>
        ))}
      </PlanTypeWrapper>
      <CardWrapper>
        {products.map((product) => (
          <PlanCard
            key={product.id}
            currentType={currentType}
            product={product}
            onManageLink={onManageSubscriptionClick}
          />
        ))}
      </CardWrapper>
    </PageWrapper>
  );
};
